import { FC } from "react";

import { m } from "@recobra/i18n/messages";

/** Minimal route/auth loading indicator (screen-reader only). */
export const PageContentFallback: FC = () => (
  <span className="sr-only" aria-live="polite">
    {m.loading_page()}…
  </span>
);
